import React, { useState } from 'react';
import type { LifeProfile } from '../types/life';
import { computeStats, parseDate, toISODate } from '../utils/lifeGrid';
import { formatNumber, plural } from '../utils/format';
interface ProfileFormProps {
  initial: LifeProfile | null;
  submitLabel: string;
  onSubmit: (profile: LifeProfile) => void;
  onCancel?: () => void;
}
const inputClass = 'w-full border border-line bg-paper px-3 py-2.5 font-mono text-sm text-ink outline-none transition-colors duration-150 ease-swift focus:border-accent';
export function ProfileForm({
  initial,
  submitLabel,
  onSubmit,
  onCancel
}: ProfileFormProps) {
  const [birthDate, setBirthDate] = useState<string>(initial?.birthDate ?? '');
  const [lifeExpectancy, setLifeExpectancy] = useState<number>(initial?.lifeExpectancy ?? 80);
  const valid = Boolean(birthDate) && !Number.isNaN(parseDate(birthDate).getTime());
  const preview = valid ? computeStats({
    birthDate,
    lifeExpectancy
  }, new Date()) : null;
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!valid) return;
    onSubmit({
      birthDate,
      lifeExpectancy
    });
  };
  return <form onSubmit={submit} className="space-y-6" data-id="element-81" data-mp="19f528zbdin2s">
      <div className="space-y-2" data-id="element-82" data-mp="19gg1cltvj6nk">
        <label htmlFor="birth" className="text-muted block text-xs font-medium" data-id="element-83" data-mp="1nenxwsn005y7">
          Дата рождения
        </label>
        <input id="birth" type="date" value={birthDate} max={toISODate(new Date())} min="1900-01-01" onChange={e => setBirthDate(e.target.value)} className={inputClass} required data-id="element-84" data-mp="1ie04y1f7lf1c" />
      </div>

      <div className="space-y-2" data-id="element-85" data-mp="2655p2ss6mthg">
        <div className="flex items-baseline justify-between" data-id="element-86" data-mp="2644bohnp1uwk">
          <label htmlFor="expectancy" className="text-muted text-xs font-medium" data-id="element-87" data-mp="21517ezfjfspn">
            Ожидаемая продолжительность жизни
          </label>
          <span className="text-ink font-mono text-sm tabular-nums" data-id="element-88" data-mp="2g31ur52cow86">
            {lifeExpectancy} {plural(lifeExpectancy, ['год', 'года', 'лет'])}
          </span>
        </div>
        <input id="expectancy" type="range" min={40} max={110} step={1} value={lifeExpectancy} onChange={e => setLifeExpectancy(Number(e.target.value))} className="w-full cursor-pointer" style={{
        accentColor: 'var(--accent)'
      }} data-id="element-89" data-mp="2i888d7wqsl15" />
      </div>

      {preview && <p className="text-muted border-line border-t pt-4 text-xs leading-relaxed" data-id="element-90" data-mp="31v66i9un6xmq">
          Прожито <span className="text-ink font-mono tabular-nums" data-id="element-91" data-mp="35w80oc9pcjhu">{formatNumber(preview.weeksLived)}</span>{' '}
          {plural(preview.weeksLived, ['неделя', 'недели', 'недель'])}. Осталось{' '}
          <span className="text-accent font-mono tabular-nums" data-id="element-92" data-mp="3funoo6dfncn4">{formatNumber(preview.weeksLeft)}</span>{' '}
          {plural(preview.weeksLeft, ['неделя', 'недели', 'недель'])}.
        </p>}

      <div className="flex items-center gap-3" data-id="element-93" data-mp="1lgmw238h7lvh">
        <button type="submit" disabled={!valid} className="bg-ink text-paper hover:bg-accent disabled:text-muted disabled:bg-line px-5 py-2.5 text-sm font-semibold transition-colors duration-150 ease-swift disabled:cursor-not-allowed" data-id="element-94" data-mp="1lhfsobdq0uzw">
          {submitLabel}
        </button>
        {onCancel && <button type="button" onClick={onCancel} className="text-muted hover:text-ink px-2 text-sm transition-colors duration-150 ease-swift" data-id="element-95" data-mp="144zizbpc06hm">
            Отмена
          </button>}
      </div>
    </form>;
}